import { FormGroup, AbstractControl } from '@angular/forms';
export class EmailValidation {

    static MatchEmail(group: AbstractControl) {
        let emailField = group.get('email');
        let confirmEmailField = group.get('confirmEmail');
        if(emailField == null || confirmEmailField == null){
            return null;
        }
        let email = emailField.value;
        let confirmEmail = confirmEmailField.value;
        if(email != confirmEmail) {
            confirmEmailField.setErrors({nomatch:true}); 
        } else {
            confirmEmailField.setErrors(null);
            return null;
        }
    }
}